import { z } from 'zod';
import { zPrinterInterface, zPrinterSdk } from '../enums';

export const posPrinterSchema = z.object({
  /**
   * For a USB printer, the `uuid` of the iPad it is physically plugged into (a USB printer is
   * attached to exactly one device). `null` for LAN printers and unattached printers. This is the
   * single owner-authored, posConfig-coupled device fact; its integrity (each iPad has ≤1 USB
   * printer) is a single-document `posConfigStrictSchema` refine.
   */
  attachedToIPadUuid: z.string().nullable().default(null).optional(),
  /**
   * When true, the printer's buzzer sounds an alarm after printing a kitchen docket.
   * Buzzer connects to RJ11 port on the printer.
   **/
  buzzerEnabled: z.boolean().optional(),
  /** if `discoveryFailedAt` is null, then the printer is ONLINE. */
  discoveryFailedAt: z.number().nullable().default(null),
  docketTemplateUuids: z.array(z.string()).default([]),
  identifier: z.string(),
  interface: zPrinterInterface,
  model: z.string().nullable().default(null),
  name: z.string().default('Main printer'),
  /** Which native SDK discovered this printer and is used to communicate with it. */
  sdk: zPrinterSdk.default('STAR_MICRONICS').optional(),

  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
});
export type PosPrinter = z.output<typeof posPrinterSchema>;

export const posPrinterStrictSchema = posPrinterSchema.safeExtend({
  docketTemplateUuids: z.array(z.guid()),
});

/** When printer SDK discovers a printer, it will return this shape, which is a subset of `PosPrinter` */
export const posPrinterDiscoveredSchema = posPrinterSchema.pick({
  identifier: true,
  interface: true,
  model: true,
  sdk: true,
});
export type PosPrinterDiscovered = z.output<typeof posPrinterDiscoveredSchema>;

export const posPrinterCvxSchema = posPrinterSchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type PosPrinterCvx = z.output<typeof posPrinterCvxSchema>;
